import { getGoogleAnalyticsClientIdFromCookie } from 'helpers/integrations/GoogleAnalytics';
import { X_GA_CLIENT_ID_HEADER_NAME } from 'helpers/restclient/headers';

const googleAnalyticsClientIdInterceptor = async (config) => {
	try {
		const gaClientId = getGoogleAnalyticsClientIdFromCookie();

		if (gaClientId) {
			config.headers[X_GA_CLIENT_ID_HEADER_NAME] = gaClientId;

			if (!config.metadata) {
				config.metadata = {};
			}
			config.metadata.googleAnalyticsClientId = gaClientId;
		}
	} catch (error) {
		config.headers[X_GA_CLIENT_ID_HEADER_NAME] = undefined;
	}

	return config;
};

export default googleAnalyticsClientIdInterceptor;
